import format from "date-fns/format";
import useApiRequest from "../../../../../utils/hooks/useApiRequest";
import { ADD_TO_BASKET_URL } from "../../../../api/apiRoutes";
import { setBasketItemLimited } from "../../../../models/BasketItem";
import useFacility from "../../../../../utils/hooks/useFacility";
import { BasketItem } from "../../../../models/BasketItem";
import { useState } from "react";

export default function useBasketSocks() {
  const { post } = useApiRequest();
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);

  const addGuideToBasket = async (ids: number, qnt: number) => {
    setLoading(true);
    const formattedDate = format(new Date(), "yyyy-MM-dd");
  
    await post(ADD_TO_BASKET_URL, {
      ...setBasketItemLimited(facilityIds, `0,+${ids}`, formattedDate, qnt, []),
    });
    setLoading(false);
  };

  const addSocks = async (basketList: BasketItem[]) => {
    let bilety: number = 0;
    let socks: number = 0;
    // eslint-disable-next-line array-callback-return
    basketList.map((item: BasketItem) => {

      if(facilityIds === "1227"){
if(     item.assortIds !== "0,198" &&
  item.assortIds !== "0,199" &&
  item.assortIds !== "0,200" &&
  item.assortIds !== "0,201" &&
  item.assortIds !== "0,202" )
   
        {
          bilety = bilety + item.qnt;
        }


      }
        

      if (facilityIds !== "1227") {
        if (
          item.assortIds !== "0,203" &&
          item.assortIds !== "0,620" &&
          item.assortIds !== "0,635" &&
          item.assortIds !== "0,204" &&
          item.assortIds !== "0,206" &&
          item.assortIds !== "0,622" &&
          item.assortIds !== "0,634" &&
          item.assortIds !== "0,621" &&
          item.assortIds !== "0,636" &&
          item.assortName !== "SKARPETKI ANTYPOŚLIZGOWE" &&
          item.assortName !== "KARTA PODARUNKOWA" &&
          item.assortName !== "KARTA PODARUNKOWA GRUPA 4 OSOBY" &&
          item.assortName !== "KARTA PODARUNKOWA Z TRENEREM" &&
          item.assortName !== "Karta Podarunkowa 70 min." &&
          item.assortName !== "KARTA PODARUNKOWA 70 min" &&
          item.assortName !== "Karta Podarunkowa 130 min." &&
          item.assortName !== "KARTA PODARUNKOWA 130 min" &&
          item.assortName !== "Karta Podarunkowa No Limit" &&
          item.assortName !== "Karta Podarunkowa dla 4 osób 70 min." &&
          item.assortName !== "Karta Podarunkowa dla 4 osób 70 min" &&
          item.assortName !== "Karta Podarunkowa dla 4 osób 130 min." &&
          item.assortName !== "Karta Podarunkowa dla 4 osób 130 min" &&
          item.assortName !== "PRZEDSPRZEDAŻ - Happy Nocka" &&
          item.assortName !== "Happy Nocka" &&
          item.assortName !== "KARTA PODARUNKOWA Z TRENEREM"
        ) {
          bilety = bilety + item.qnt;
        }
      }




      if (item.assortName === "SKARPETKI ANTYPOŚLIZGOWE") {
        socks = socks + item.qnt;
      }
    });

    setTimeout(() => {
      // 21/

      if (bilety - socks > 0) {
        if (facilityIds === "1227") {
          addGuideToBasket(21, bilety - socks);
        }
        if (facilityIds === "1200") {
          addGuideToBasket(167, bilety - socks);
        }
        if (facilityIds === "1204") {
          addGuideToBasket(167, bilety - socks);
        }
      }
    }, 100);
  };

  return {
    addSocks,
    loading,
  };
}
